<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台工程师管理规则</div>
    <div class="main_item">
      <h2>第一章&nbsp;概述</h2>
      <ul class="content_wrap1">
        <li>
          <p>目的及依据</p>
          <p>
            为维护神州邦邦平台的管理秩序，保障神州邦邦平台交易各方合法权益，依据《神州邦邦平台服务协议》《神州邦邦平台服务规则》《神州邦邦用户注册服务协议》等相关协议和规则，制定本规则。
          </p>
        </li>
        <li>
          <p>适用范围</p>
          <p>
            本规则适用于使用神州邦邦平台的所有工程师及雇主（用户在登录神州邦邦
            平台后根据自身需求，自主选择自己的身份是“工程师”或“雇主”）。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第二章&nbsp;工程师行为规范</h2>
      <ul class="content_wrap1">
        <li>
          <p>信息发布或出售</p>
          <p>
            工程师在完善个人信息、发布服务和案例等涉及到信息发布或出售的情况下，需遵循以下要求：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                工程师发布的信息包括：工程师昵称、工程师头像、公司简介、提供的服务、案例展示等展示的所有信息，所有信息发布必须合法、合规，并遵循《神州邦邦平台服务规则》相关规定。所有信息发布通过神州邦邦平台审核后才能成功发布，但神州邦邦平台不对该信息的合法性、真实性承担任何法律责任；
              </p>
            </li>
            <li>
              <p>工程师具有售卖或发布服务所需的全部资质；</p>
            </li>
            <li>
              <p>发布的服务必须具有明确的、向用户公示的产品说明或服务条款；</p>
            </li>
            <li>
              <p>
                工程师应保证其发布的服务不会侵犯任何第三人（方）的合法权益；
              </p>
            </li>
            <li>
              <p>
                发布的服务标题、图片、属性、价格、服务描述等服务要素之间应当互相匹配对应，并且服务详情页面、案例等页面中无嵌入非神州邦邦平台的外部链接地址，不得抄袭其他工程师、商品、服务、案例等信息，不得侵犯任何第三人（方）的合法权益；
              </p>
            </li>
            <li>
              <p>
                工程师违反上述要求造成的一切后果由工程师自行承担，如果给神州邦邦平台造成损失，工程师应承担相应的赔偿责任。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>服务承诺</p>
          <p>
            在交易过程中，工程师应当遵守本规则，并按照约定（包括但不限于订单内容、或服务全程监管、或神州邦邦平台规定的工程师应遵守的其他规定、或工程师自行向雇主作出的服务承诺）提供服务。工程师未能履行服务承诺的，包括但不限于：过度承诺引起投诉的、拒绝在合理范围提供修改服务、无法在约定时间内交付工作、无法按照约定标准交付等行为，神州邦邦平台有权通过划扣工程师缴存的保证金进行赔付。
          </p>
        </li>
        <li>
          <p>售后服务</p>
          <ul class="content_wrap2">
            <li>
              <p>
                工程师在提供服务后，应提供服务售后支持，例如电话支持，技术支持，服务支持等。售后服务需产生费用的，工程师应当明示收费项目及标准。
              </p>
            </li>
            <li>
              <p>
                工程师提供收费售后服务的，如因服务不可用，工程师应提供替代方案或退款等解决措施。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>发票</p>
          <ul class="content_wrap2">
            <li>
              <p>企业类工程师有向神州邦邦平台开票的义务。</p>
            </li>
            <li>
              <p>企业类工程师不得出现拒绝为神州邦邦平台开具发票的行为。</p>
            </li>
            <li>
              <p>企业类工程师不得出现为神州邦邦平台开具假发票的行为。</p>
            </li>
            <li>
              <p>企业类工程师不得额外向神州邦邦平台收取稅点进行开票。</p>
            </li>
            <li>
              <p>
                企业类工程师开具的发票需保证准确、清晰（包括但不限于抬头、金额、公章）。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>禁止线下交易</p>
          <p>
            一、线下交易：指工程师在神州邦邦平台获取雇主信息，在首次及后续交易过程中，引导或接受雇主在神州邦邦平台之外进行交易，包括不限于以下情形：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                工程师引导或接受雇主通过神州邦邦平台以外渠道下单交易（包含但不限于接受雇主通过非神州邦邦平台收款等），均属于实施线下交易；
              </p>
            </li>
            <li>
              <p>
                工程师主动引导或接受雇主脱离神州邦邦平台进行交易，但最终未实施的（包含但不限于引导雇主通过非神州邦邦平台收款等），均属于引导线下交易违规行为。
              </p>
            </li>
          </ul>
          <p>处理措施：若工程师出现以上违规行为，将参照如下条款处理：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                引导线下交易的，神州邦邦平台有权对此工程师名下所有账号（包含以相同证件认证的或通过技术手段确认相关联的所有或部分账户），第一次限制操作15天，并按照平台的要求以书面形式承诺不会再次引导或实施线下交易的行为；第二次直接清退，扣除所有保证金的处理。
              </p>
            </li>
            <li>
              <p>
                实施线下交易的，神州邦邦平台有权对此工程师名下（包含以相同证件认证的或通过技术手段确认相关联的所有或部分账户），第一次限制操作15天，并扣除工程师500元保证金的处理，并按照平台的要求以书面形式承诺不会再次引导或实施线下交易的行为；第二次直接清退，扣除所有保证金的处理。
              </p>
            </li>
          </ul>
          <p>
            二、用户因线下交易造成的一切经济损失由用户自行承担，神州邦邦平台将不承担任何责任。
          </p>
        </li>
        <li>
          <p>禁止引流交易</p>
          <p>引流交易指：工程师引导或引流雇主到其他平台进行交易的：</p>
          <ul class="content_wrap2">
            <li>
              <p>工程师将雇主引流到其他平台进行交易的，无论雇主是否同意；</p>
            </li>
            <li>
              <p>其他抢占用户资源的行为。</p>
            </li>
          </ul>
          <p>
            工程师进行引流交易的，神州邦邦平台有权对该工程师处以直接清退，并扣除全部保证金。用户因引流行为造成的一切经济损失由用户自行承担，神州邦邦平台不承担任何法律责任。
          </p>
        </li>
        <li>
          <p>禁止虚假交易（刷单）</p>
          <p>
            虚假交易（刷单）：指工程师通过虚构或隐瞒交易事实、利用或规避信用记录规则、干扰或妨害信用记录秩序等不正当方式获取虚假的成单数量、评分、邦豆等不当利益，破坏正常交易秩序的行为。虚假交易行为包括但不限于以下情形：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>工程师雇佣自己进行虚假交易的；</p>
            </li>
            <li>
              <p>
                工程师利用第三方炒作团伙或通过与他人协议交换购买的方式提高成单数量的；
              </p>
            </li>
            <li>
              <p>
                工程师引导雇主中标，协商退款或全额支付后，对雇主进行汇款、转账或充值而进行变相返现退款的行为。
              </p>
            </li>
          </ul>
          <p>
            工程师进行虚假交易，神州邦邦平台有权根据违规行为的情节进行处理，包括但不限于剔除虚假交易产生的成单数量、取消推荐、限制操作等，并对工程师处以单次扣除保证金500元；情节严重者将对工程师直接清退并扣除全部保证金。
          </p>
          <p>
            用户因虚假交易造成的一切经济损失由其自行承担，神州邦邦平台不承担任何法律责任。
          </p>
        </li>
        <li>
          <p>禁止不正当竞争</p>
          <ul class="content_wrap2">
            <li>
              <p>
                诱导选标、付款：工程师通过故意曲解神州邦邦平台规则和交易流程等方式诱骗雇主选标、付款的行为神州邦邦平台将参照《神州邦邦平台纠纷处理规则》相关条款处理。
              </p>
            </li>
            <li>
              <p>
                恶意评价：指评价人脱离实际情况，采取恶意诋毁等方式对他人进行评价的行为。神州邦邦平台将参照《神州邦邦平台交易评价规则》相关条款执行处理。
              </p>
            </li>
            <li>
              <p>
                恶意抄袭：指平台上同行经营者为了不正当竞争，恶意抄袭他人的主页形象、详情大图等，从而引起用户混淆，导致被抄袭方遭受订单损失、流量损失的，神州邦邦平台有权对此工程师处以限制操作7天，并扣除500元保证金。
              </p>
            </li>
            <li>
              <p>
                恶意举报：用户通过举报干扰他人正常交易的行为。恶意举报包含但不限于以下情形：
              </p>
              <p>
                1、用户自己或利用他人，对竞争对手的正常信息（包括但不限于投标，需求，评论，服务），在短时间内进行多次举报，严重妨碍工程师正常交易活动的行为。
              </p>
              <p>
                2、用户利用其他账号，进行虚假举报，对正常交易进行干扰，妨碍他人进行合理操作的行为。
              </p>
              <p>
                一经查实，本网站有权对该用户处以限制操作15天，扣除500元保证金的处理。
              </p>
            </li>
            <li>
              <p>
                虚假举证：指当任意一方接到举报或纠纷时，假冒对方向神州邦邦平台表示撤销投诉；或虚构事实，隐瞒实情，阻碍神州邦邦平台正常调查的行为。一经查实，本网站有权对该方处以限制操作15天，扣除500元保证金的处理。
              </p>
            </li>
            <li>
              <p>
                工程师自己或利用他人，通过捏造、散布虚伪事实等不正当手段，对竞争对手的商业信誉进行恶意的诋毁、贬低，以削弱其市场竞争能力的。神州邦邦平台有权对工程师处以限制操作7天的处理；涉及严重违规的，将对此工程师处以直接清退，并扣除全部保证金。
              </p>
            </li>
            <li>
              <p>
                用户违反以上条款，产生的一切后果由其自行承担，如给神州邦邦平台造成损失，用户应承担相应的赔偿责任。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>禁止虚假认证</p>
          <p>
            虚假认证指个人用户或企业用户使用虚假资质或虚假信息入驻神州邦邦平台的行为。虚假认证的，神州邦邦平台将参照《神州邦邦平台服务规则》相关条款执行处理。
          </p>
        </li>
        <li>
          <p>禁止侵犯他人权利</p>
          <p>
            侵犯他人权利指工程师未经授权以不正当手段获取、未经允许发布、传递他人隐私信息，或其他涉嫌侵犯他人人身权利的行为。神州邦邦平台将参照《神州邦邦平台服务规则》相关条款执行处理。
          </p>
        </li>
        <li>
          <p>禁止不正当牟利</p>
          <p>
            不正当牟利：指平台用户采用不正当手段牟取利益或采用其他手段牟取不正当利益的行为，该行为一经查实，神州邦邦平台将参照《神州邦邦平台服务规则》相关条款执行处理。
          </p>
        </li>
        <li>
          <p>禁止恶意营销、恶意炒作</p>
          <p>
            恶意营销、恶意炒作：指用户对社会热点事件、敏感事件的进行恶意营销、炒作的，神州邦邦平台有权利视情节轻重采取产品下架、信息屏蔽、锁定账号等处理。
          </p>
        </li>
        <li>
          <p>
            批量注册：指用户通过软件、程序、人工等方式，大批量注册神州邦邦平台账户，或利用通过已批量注册的神州邦邦平台账户，滥用会员权利、损害他人合法权益、妨碍神州邦邦平台运营秩序的行为。神州邦邦平台批量注册的，神州邦邦平台将参照《神州邦邦平台服务规则》相关条款执行处理。
          </p>
        </li>
        <li>
          <p>违反服务承诺规则</p>
          <p>
            未能履行双方已确认的服务承诺的，包括但不限于未完成的过度承诺引起雇主投诉的，如无法在约定时间内交付工作、无法按照约定标准交付工作等行为，详见《神州邦邦平台纠纷处理规则》。
          </p>
        </li>
        <li>
          <p>延期提现</p>
          <p>
            延期提现：指在特定情况下，神州邦邦平台用户的部分或全部资金将被冻结，中止提现的情形。
          </p>
          <p>一、延期提现的情形包括但不限于：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                涉嫌违反国家法律、法规的交易，包括但不仅限于提供虚假商品或服务、骗取他人财物、危及交易安全、发布违禁信息、发布禁售信息等；
              </p>
            </li>
            <li>
              <p>当神州邦邦平台用户的账号存在账号被盗等安全风险时；</p>
            </li>
            <li>
              <p>
                交易行为或交易流程存在异常，如：交易履行风险较高的订单，存在虚假交易的订单，提供劣质作品或服务的订单；
              </p>
            </li>
            <li>
              <p>
                所提供的商品或服务已引发司法调查、行政监管、媒体报道、公众质疑等风险情形；
              </p>
            </li>
            <li>
              <p>其他神州邦邦平台认为需要进行交易资金保障的情形。</p>
            </li>
          </ul>
          <p>延期提现周期：被认定为延期提现情形的，限制提现的周期为60天。</p>
          <p>延期提现解除：</p>
          <ul class="content_wrap2">
            <li>
              <p>
                申诉成功：针对可以申诉的延期提现情况，您可以进行申诉。若申诉成功，延期提现立即解除。若申诉不成功或未申诉，则该资金继续不可用直至延期提现到期后解除；
              </p>
            </li>
            <li>
              <p>
                延期提现到期：延期提现期限内用户无官方调解需求，则延期提现立即解除。在此期间，若用户发起官方介入调解申请，涉及款项将以有权机关判定结果为准。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第三章&nbsp;用户退款管理</h2>
      <ul class="content_wrap1">
        <li>
          <p>退款</p>
          <p>
            在神州邦邦平台交易过程中，雇主可能会因服务质量、服务不满意等原因发起退款要求。
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                一般情况下，雇主发起退款请求时，工程师应与之进行协商。若协商结果不能一致，则双方可向神州邦邦平台申请官方调解，按《神州邦邦平台纠纷处理规则》执行。
              </p>
            </li>
            <li>
              <p>
                若工程师加入了神州邦邦平台推出的特殊服务，或使用类似的特殊产品标识时，应该以活动或产品中规定的退款要求为雇主提供服务。若不能提供服务，并引起雇主投诉时，神州邦邦平台有权按服务或产品中所规定的内容执行退款。
              </p>
            </li>
            <li>
              <p>
                持卡人拒付：当发生国内银行卡持卡人对交易提出拒付时，神州邦邦平台将配合银行要求工程师提供真实交易材料，工程师未能按时提供或提供材料未获得银行及持卡人认可时，该笔交易的损失由商户全额承担。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第四章&nbsp;平台运营</h2>
      <ul class="content_wrap1">
        <li>
          <p>行为规范</p>
          <ul class="content_wrap2">
            <li>
              <p>
                未经神州邦邦平台事先书面授权，不得以神州邦邦平台或神州邦邦平台其他关联公司等名义进行任何销售及宣传活动，包括但不限于电话，函件，邮件，文档等，否则神州邦邦平台有权对该工程师处以直接清退，并扣除全部保证金的处理
                ；
              </p>
            </li>
            <li>
              <p>
                不得损害神州邦邦平台品牌和形象，直接或间接仿冒产品，否则神州邦邦平台有权对该工程师处以直接清退，并扣除全部保证金的处理
                ；
              </p>
            </li>
            <li>
              <p>
                软件开发类服务过程中不得出现帐号提权、安装后门程序等主动危害系统安全的行为，不得隐瞒其所发现的系统缺陷且恶意利用，应及时告知雇主，否则神州邦邦平台有权对该工程师处以直接清退，并扣除全部保证金的处理。因该行为给用户造成的一切损失，由工程师自行承担；
              </p>
            </li>
            <li>
              <p>
                不得辱骂、恐吓、污蔑、要挟、威胁其他用户，若工程师/雇主通过沟通工具（包括但不限于IM、QQ、电话、邮件）对雇主/工程师进行辱骂、诋毁、要挟、诽谤、人身攻击等，将参照如下条款处理：
              </p>
              <p>
                1、单次限制操作7天，扣除保证金500元；若交易双方自行协商沟通，友好解决，处以单次限制操作7天的处理；
              </p>
              <p>2、行为恶劣，情节严重的，平台有权直接清退并扣除全部保证金。</p>
              <p>
                是否属于“辱骂、诋毁、要挟、诽谤、人身攻击等行为”由神州邦邦平台以普通大众的认知水准及日常经验进行判断，神州邦邦平台不对此判断结果承担责任。
              </p>
            </li>
            <li>
              <p>
                工程师应当仅获取为提供神州邦邦平台服务而必要的信息，且工程师在服务过程中收集的信息仅可在为某一特定雇主提供神州邦邦平台服务过程中使用；工程师不得将收集的信息用于服务之外的任何目的，不得将信息出售、转让或向任何第三方披露，也不得超范围收集雇主信息；前述信息包括但不限于雇主会员名称、手机号码、地址等，否则神州邦邦平台将参照《神州邦邦平台服务规则》“侵犯他人权利”相关条款执行处理；
              </p>
            </li>
            <li>
              <p>
                不得未经神州邦邦平台同意向雇主发送服务推广信息，或通过任何方式对雇主造成骚扰，否则神州邦邦平台将参照《神州邦邦平台服务规则》“骚扰他人”相关条款执行处理；
              </p>
            </li>
            <li>
              <p>
                不得未经神州邦邦平台及雇主授权，非法获取、使用如：电话、地址、身份等信息，否则神州邦邦平台将参照《神州邦邦平台服务规则》“侵犯他人权利”相关条款执行处理；
              </p>
            </li>
            <li>
              <p>
                不得通过非法手段盗取他人神州邦邦平台账户，涉嫌侵犯他人财产权的行为，否则神州邦邦平台将参照《神州邦邦平台服务规则》“盗取他人账户”相关条款执行处理；
              </p>
            </li>
            <li>
              <p>
                不得通过神州邦邦平台以非法获利为目的，以欺诈、盗取、骗取等手段非法获取他人财物，涉嫌侵犯他人财产权的行为，否则神州邦邦平台将参照《神州邦邦平台服务规则》“骗取他人财物”相关条款执行处理；
              </p>
            </li>
            <li>
              <p>
                不得通过神州邦邦平台系统进行任何危害计算机网络安全的行为，以任何方式损坏或破坏神州邦邦平台系统，使神州邦邦平台系统不能运行或超负荷，干扰第三方对神州邦邦平台系统的使用的行为，否则神州邦邦平台将参照《神州邦邦平台服务规则》“黑客行为”相关条款执行处理；
              </p>
            </li>
            <li>
              <p>
                工程师在服务过程中应做好数据备份等工作，完结后及时删除备份的数据，不得因人为失误造成雇主损失，否则若双方已有约定的，从其约定；若无约定，且该订单已经产生支付的，则由神州邦邦平台从工程师所缴纳的保证金中划扣与该交易中雇主所支付金额相等的款项赔付给雇主，以弥补雇主损失。若工程师保证金不足，神州邦邦平台将应雇主要求披露工程师信息，以协助雇主通过司法途径向工程师进行主张；如因工程师操作失误或者因未及时删除数据而造成任何违反法律法规的行为，由工程师自行承担全部责任，神州邦邦平台对此不负任何责任。
              </p>
            </li>
            <li>
              <p>
                当工程师提供的服务因为版权问题（包括神州邦邦平台接到投诉或有合理理由判断的情况），被版权所有方追责，工程师应采取有效措施停止侵权：
              </p>
              <p>（一）停止提供该服务；</p>
              <p>
                （二）为已使用该服务的雇主，提供替代该服务或其他解决方案，并负责为雇主提供在此过程中所需要的数据迁移及其他相关服务及费用；
              </p>
              <p>（三）其他积极有效的措施。</p>
              <p>
                否则神州邦邦平台将参照《神州邦邦平台侵权处理规则》第五条执行。
              </p>
            </li>
            <li>
              <p>
                工程师应当按照《电子商务法》等法律法规的的相关要求办理市场主体登记，若属于依照相关法律法规不需要办理市场主体登记的需要进行说明，工程师需对其提供的说明信息真实性负责，若存在与事实不符的，神州邦邦平台将暂时限制操作直至工程师更正相关说明。
              </p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第五章&nbsp;违规处理</h2>
      <ul class="content_wrap1">
        <li>
          <p>违规情形与处理</p>
          <ul class="content_wrap2">
            <li>
              <p>
                工程师进行违规行为，神州邦邦平台有权按照相关规定进行相应的处理。
              </p>
            </li>
            <li>
              <p>
                工程师进行违规行为，神州邦邦平台有权根据实际情况，视情节轻重在既有规定基础之上予以从轻、减轻或免除处理。
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>节点处理</p>
          <p>
            神州邦邦平台有权对工程师进行认定并进行处理，处理的方式包括但不限于以下措施：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>
                保证金扣除：指依据工程师不同的违规行为予以扣除部分或全部保证金的方式；
              </p>
            </li>
            <li>
              <p>《神州邦邦平台服务规则》等相关规则中规定的违规处理措施。</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第六章&nbsp;退出管理</h2>
      <ul class="content_wrap1">
        <li>
          <p>主动退出</p>
          <p>
            工程师有权根据自身的实际经营情况，退出神州邦邦平台。但应当提前三十日在神州邦邦平台个人信息显著位置持续公示有关信息。
          </p>
        </li>
        <li>
          <p>清退</p>
          <p>
            工程师如出现以下任一情形，神州邦邦平台有权立即将其清退出神州邦邦平台：
          </p>
          <ul class="content_wrap2">
            <li>
              <p>工程师出现上文【违规处理】里所列的应被清退的情形；</p>
            </li>
            <li>
              <p>不符合相应的提供服务条件；</p>
            </li>
            <li>
              <p>
                工程师会员账户因违反神州邦邦平台的其他规则，已被神州邦邦平台列黑名单或清退的；
              </p>
            </li>
            <li>
              <p>
                存在恶意竞争、影响用户权益、影响神州邦邦平台声誉等违反市场公平竞争原则、诚实信用原则、公序良俗的行为；
              </p>
            </li>
            <li>
              <p>
                通过不正当手段使用神州邦邦平台注册LOGO、域名等用于不正当宣传、商业活动，给用户造成误导、侵犯神州邦邦平台知识产权等给神州邦邦平台造成影响的的行为；
              </p>
            </li>
            <li>
              <p>
                在线上、线下等渠道，通过文字或图片等方式发布恶意诋毁神州邦邦平台的言论，给神州邦邦平台造成不良影响的行为；
              </p>
            </li>
            <li>
              <p>擅自转让或授权他人使用自己在神州邦邦平台帐号的行为；</p>
            </li>
            <li>
              <p>其他神州邦邦平台认定工程师严重违规的行为。</p>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <h2>第七章&nbsp;附则</h2>
      <ul class="content_wrap1">
        <li>
          <p>本规则发布之日起即生效并执行。</p>
        </li>
        <li>
          <p>
            神州邦邦平台工程师行为，发生在本规则生效之日或修订之日以前的，适用当时的规则；发生在本规则生效之日或修订之日以后的，适用本规则。
          </p>
        </li>
        <li>
          <p>
            神州邦邦平台有权根据市场环境、合作商合作体系发展状况等因素对本管理规则做相应的修订。
          </p>
        </li>
        <li>
          <p>本规则最终解释权归神州邦邦平台。</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>